import { useLingui } from '@lingui/react'
import { Trans } from '@lingui/macro'
import { Container, Typography } from '@mui/material'
import FormTemplatesContainer from './containers/FormTemplatesContainer'

function FormTemplatesPage() {
  useLingui()
  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        <Trans>Form Templates Management</Trans>
      </Typography>
      <FormTemplatesContainer />
    </Container>
  )
}

export default FormTemplatesPage
